<template>
  <div v-if="dataPermission && dataPermission.includes('CNPS_CSS_VA_QR_DETAIL')">
    <div class="breadcrumb-area pos-relative w-100">
      <h1 style="font-size: 18px; font-weight: 500">
        Chi tiết
        <span class="font-weight-bold" style="font-size: 20px">Sticker QR VA</span>
      </h1>
      <div class="float-right">
        <button
          type="button"
          class="font-medium f12 btn btn-outline-secondary m-r-10"
          @click="$router.push('/customer-support/account-qr')"
        >
          <b-icon icon="arrow-left" aria-hidden="true" />
          Quay lại
        </button>
      </div>
      <hr />
    </div>

    <b-row class="gx-4 px-20">
      <b-col cols="6" md="6">
        <DetailInfo
          title="Thông tin Sticker QR"
          :info="info"
          :isLoading="isLoading"
          :fields="fieldsStickerQr"
        >
          <template #bankCode="{ value }">
            {{ getBankName(value) || value }}
          </template>
          <template #lastModifiedPrinted="{ value }">
            {{ value | formatDate('HH:mm, DD/MM/YYYY') }}
          </template>
          <template #lastModifiedPasted="{ value }">
            {{ value | formatDate('HH:mm, DD/MM/YYYY') }}
          </template>
          <template #lastModifiedStop="{ value }">
            {{ value | formatDate('HH:mm, DD/MM/YYYY') }}
          </template>
          <template #status>
            <b-badge :variant="statusColor">{{ getNameStatus }}</b-badge>
          </template>
        </DetailInfo>
      </b-col>
    </b-row>
  </div>
</template>
<script>
  import { mapGetters } from 'vuex'
  import { DetailStickerVa } from '@/services/customer-support/account'
  import { showMess } from '@/config/utils'
  import { CommonService } from '@/services/common.service'
  import moment from 'moment'
  import DetailInfo from '@/components/cskh/DetailInfo'

  export default {
    components: {
      DetailInfo,
    },
    data() {
      return {
        moList: [],
        maList: [],
        storeList: [],
        isLoading: false,
        mappingLabel: [],
        mappingStatus: [],
        id: '',
        info: {},
        listBankCode: [],
        fieldsMerchantInfo: [
          { key: 'merchantAccountInfo.name', label: 'Tên merchant' },
          { key: 'merchantAccountInfo.email', label: 'Email' },
          { key: 'mobileUserName', label: 'Địa chỉ' },
        ],
        fieldsStickerQr: [
          { key: 'bankCode', label: 'Ngân hàng' },
          { key: 'name', label: 'Tên tài khoản' },
          { key: 'virtualAccount', label: 'Tài khoản VA' },
          { key: 'lastModifiedPrinted', label: 'Ngày in' },
          { key: 'lastModifiedPasted', label: 'Ngày dán' },
          { key: 'lastModifiedStop', label: 'Ngày huỷ' },
          { key: 'status', label: 'Trạng thái' },
        ],
      }
    },

    created() {
      this.id = this.$router.currentRoute.params.id
    },

    async mounted() {
      await this.configSystem()
      if (this.dataPermission.includes('CNPS_CSS_QR_GET_DETAIL')) {
        await this.loadData()
      } else {
        this.$bvModal
          .msgBoxOk('Bạn không có quyền truy cập vào trang này', {
            title: 'Cảnh báo',
            okVariant: 'danger',
            headerClass: 'p-2 border-bottom-0',
            footerClass: 'p-2 border-top-0',
            centered: true,
          })
          .then(() => {
            this.$router.replace('/')
          })
      }
    },

    computed: {
      ...mapGetters({
        dataPermission: 'role/dataPermission',
      }),

      listImages() {
        return this.mappingLabel.map(i => {
          const dataImage = this.info?.images?.filter(
            item => Number(item.type) === Number(i.type)
          )[0]
          return {
            ...i,
            label: i.name,
            ...dataImage,
            url: dataImage?.linkUrl,
          }
        })
      },
      getNameStatus() {
        return this.mappingStatus.filter(i => i.code === this.info.status)[0]?.name
      },
      statusColor() {
        switch (this.info.status) {
          case 'PRINTED':
            return 'primary'
          case 'ACTIVE':
            return 'success'
          case 'PASTED_QR':
            return 'secondary'
          case 'NOT_PRINTED':
            return 'warning'
          case 'NOT_PASTED_QR':
            return 'warning'
          default:
            return 'secondary'
        }
      },
      mapBankName() {
        return this.listBankCode.reduce((map, item) => {
          map[item.id] = item.text
          return map
        }, {})
      },
      getBankName() {
        return bank => this.mapBankName[bank] || ''
      },
    },

    methods: {
      async configSystem() {
        try {
          const res = await CommonService.getConfigSystem()
          this.moList = res.data.moContact
          this.maList = res.data.maContact
          this.storeList = res.data.storeContact
          this.mappingLabel = res.data.imageQRType
          this.mappingStatus = res.data.qrStatus

          this.listBankCode = res.data.banks.map(e => {
            return {
              id: e.code,
              text: e.name,
            }
          })
        } catch (e) {
          showMess(
            this,
            'Error',
            e.response?.data?.message || e.response?.message || e.message,
            'danger',
            'b-toaster-top-right',
            5 * 60 * 60
          )
        }
      },
      formatDate(date, format = 'HH:mm, DD/MM/YYYY') {
        if (!date) return
        return moment(date).format(format)
      },
      async loadData() {
        try {
          this.isLoading = true
          const res = await DetailStickerVa(this.id)
          this.info = res.data
        } catch (e) {
          showMess(
            this,
            'Lỗi',
            e.response?.data?.message || e.response?.message || e.message,
            'danger',
            'b-toaster-top-right',
            5 * 60 * 60
          )
        } finally {
          this.isLoading = false
        }
      },
    },
  }
</script>
<style lang="scss" scoped>
  .breadcrumb {
    margin-bottom: 0;
  }

  .h-fit {
    height: fit-content !important;
  }

  .image-row {
    display: flex;
    flex-direction: column;
    gap: 8px;

    .image-row label {
      color: black;
      font-weight: 600;
    }
  }

  .h-fit-image {
    display: flex !important;
    flex-direction: column !important;
    gap: 0 !important;

    .image-container {
      height: 35px !important;
    }
  }

  label {
    color: black;
    font-weight: 600;
  }

  .image-container {
    width: 100%;
    height: 80px;
    border-radius: 4px;

    .image-layout {
      display: flex;
      gap: 10px;
      height: 70px;

      img {
        max-width: 100%;
        max-height: 100%;
        width: 70px;
        object-fit: cover;
        background: white;
        border-radius: 5px;
        border: 1px solid gray;
      }
    }

    .image-placeholder {
      color: #999;
      font-size: 13px;
      font-weight: 300;
    }
  }

  .shadow-card {
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    border-radius: 10px;
    border: 0.1px solid #e4e4e4;
  }

  .min-h-290 {
    min-height: 290px;
  }

  .h-mo {
    min-height: 430px;
  }

  .h-mo.b-table-sticky-header {
    max-height: 36.5svh !important;
  }

  .card-footer {
    background-color: #fff;
    border-top: none !important;
  }

  .b-table-sticky-header {
    min-height: 29.5svh;
    max-height: 29.5svh;
  }

  .card-title {
    font-size: 16px !important;
    font-weight: bold;
    padding-bottom: 10px;
  }

  .b-table-sticky-header {
    border-radius: 0 !important;
  }

  .form-control-plaintext,
  .col-form-label {
    padding: 0.175rem !important;
  }

  .spinner-center {
    display: flex;
    justify-content: center;
  }

  .form-group {
    margin-bottom: 0 !important;
  }

  .table td {
    background: white !important;
  }

  .b-badge {
    padding: 10px;
    font-size: 14px;
    border-radius: 4px;
  }
</style>
